import React from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '../Icon/Icon';
import { getNeutralColors } from '../theme/utils/getPaletteColors';
import { BodyText2Css } from '../typography/BodyText';
import { CaptionCss } from '../typography/Caption';

const StyledPills = styled.span`
  background: ${getNeutralColors('grisMedio')};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 8px 8px 0;
  max-width: 300px;
  overflow: hidden;
  padding: 4px 8px;
  position: relative;

  &:hover {
    background: ${getNeutralColors('grisMedioClaro')};
    color: ${getNeutralColors('black')};
  }

  ${props =>
    props.small &&
    css`
      ${CaptionCss}
      background: ${getNeutralColors('grisMedioOscuro')};
      border-radius: 23px;
      color: ${getNeutralColors('white')};
      padding: 2px 8px;

      &:hover {
        background: ${getNeutralColors('grisOscuro')};
        color: ${getNeutralColors('white')};
      }
    `};

  ${props =>
    props.disabled &&
    css`
      background: ${getNeutralColors('grisClaro')};
      color: ${getNeutralColors('grisMedioClaro')};
      cursor: not-allowed;

      &:hover {
        background: ${getNeutralColors('grisClaro')};
        color: ${getNeutralColors('grisMedioClaro')};
      }
    `};

  ${props =>
    props.outlined &&
    css`
      border: 1px solid ${getNeutralColors('grisMedio')};
      background: transparent;
      color: ${getNeutralColors('black')};

      &:hover {
        background: transparent;
        border-color: ${getNeutralColors('grisOscuro')};
        color: ${getNeutralColors('grisOscuro')};
      }

      ${props.small &&
        css`
          &:hover {
            color: ${getNeutralColors('grisOscuro')};
          }
        `}

      ${props.disabled &&
        css`
          border-color: ${getNeutralColors('grisMedio')};
          color: ${getNeutralColors('grisMedioClaro')};

          &:hover {
            border-color: ${getNeutralColors('grisMedio')};
            color: ${getNeutralColors('grisMedioClaro')};
          }
        `}
    `};
`;

const ContentWrapper = styled.span`
  ${BodyText2Css};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  padding-left: 9px;
`;

const Pill = props => {
  const { value, small, handleClick, icon } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledPills {...props}>
      <ContentWrapper title={value}>{value}</ContentWrapper>
      {handleClick && !small && (
        <IconWrapper onClick={() => handleClick(value)}>
          <Icon name={icon || 'closeCustom'} size={100} margin='0px' />
        </IconWrapper>
      )}
    </StyledPills>
  );
};

export { Pill };
